import { fullIconMap } from "./iconMap";
import { BaseComponentProps } from "../types";
import { AllIconName } from "./types";

type BaseIconProps = BaseComponentProps<
  "svg",
  {
    iconName: AllIconName;
    disabled: boolean;
  }
>;

export const BaseIcon = ({
  iconName,
  disabled = false,
  ...svgProps
}: BaseIconProps) => {
  const Component = fullIconMap[iconName];
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const { onClick, ...svgPropsWithoutOnClick } = svgProps;
  /* eslint-enable @typescript-eslint/no-unused-vars */
  const propsToPutOnSvg = disabled ? svgPropsWithoutOnClick : svgProps;
  return <Component {...propsToPutOnSvg} />;
};
